import React, {Component, Fragment} from 'react';

import ReadyButton from 'components/ReadyButton';
import AudioPlayer from 'components/AudioPlayer';

import spoonerismNo_intro from 'assets/sounds/no/spoonerism/intro.mp3';
import spoonerismNo_intro_end from 'assets/sounds/no/spoonerism/intro-end.mp3';
import spoonerismNN_intro from 'assets/sounds/nn/spoonerism/intro.mp3';
import spoonerismNN_intro_end from 'assets/sounds/nn/spoonerism/intro-end.mp3';

import spoonerismNo_intro_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-intro.mp3';
import spoonerismNo_intro_end_norming from '../../assets/sounds/no/spoonerism/norming/grade6-7/trail/Spoonerism-MT-intro-AFTER-trail.mp3';
import spoonerismNN_intro_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/Instructions.mp3';
import spoonerismNN_intro_end_norming from '../../assets/sounds/nn/spoonerism/norming/grade6-7/trail/Instructions-after-trial.mp3';

import {updateStepData} from 'api';

import listen from 'assets/listen.png';
import arrow from 'assets/arrow.png';

import {no, nn, nn_norming, no_norming} from './assets';

import strings from 'strings';

class Intro extends Component {
	constructor(props) {
		super(props);
		const {ageGroup} = this.props;
		const lang = strings.getLanguage();
		const isNormingActive = ageGroup === 6 || ageGroup === 7;

		const config = {
			nn: {
				assets: isNormingActive ? nn_norming : nn,
				intro: isNormingActive
					? spoonerismNN_intro_norming
					: spoonerismNN_intro,
				introEnd: isNormingActive
					? spoonerismNN_intro_end_norming
					: spoonerismNN_intro_end,
			},
			no: {
				assets: isNormingActive ? no_norming : no,
				intro: isNormingActive
					? spoonerismNo_intro_norming
					: spoonerismNo_intro,
				introEnd: isNormingActive
					? spoonerismNo_intro_end_norming
					: spoonerismNo_intro_end,
			},
		};

		const selected = config[lang] || config.no;

		this.assets = selected.assets;
		this.intro_audio = selected.intro;
		this.intro_audio_end = selected.introEnd;
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
		if (newProps.stepData.answered && !this.props.stepData.answered) {
			this.playFeedback(
				newProps.currentStep,
				newProps.stepData.correct,
				newProps.stepData.numberOfCorrect
			);
		}
	}
	startNewTask = (taskNumber) => {
		let audioFile;
		if (taskNumber === 1) {
			audioFile = this.assets.proveoppgave1;
		} else if (taskNumber === 2) {
			audioFile = this.assets.proveoppgave2;
		} else if (taskNumber === 3) {
			audioFile = this.assets.proveoppgave3;
		}
		if (audioFile) {
			const myCallback = () => {
				//audioFile.removeEventListener('ended', myCallback);
				//start timer
			};
			audioFile.on('end', myCallback);
			audioFile.play();
		}
	};

	initializeAudio = () => {
		Object.values(this.assets).forEach((audioEl) => audioEl.load());

		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			1000
		);
	};

	playFeedback = (task, correct, ifOneCorrect) => {
		let audioFile;
		const {ageGroup} = this.props;
		const isNormingActive = ageGroup === 6 || ageGroup === 7;

		if (task === 1) {
			if (ifOneCorrect && isNormingActive) {
				audioFile = this.assets.ifonecorrect1;
			} else {
				audioFile = correct
					? this.assets.correct1
					: this.assets.incorrect1;
			}
		} else if (task === 2) {
			if (ifOneCorrect && isNormingActive) {
				audioFile = this.assets.ifonecorrect2;
			} else {
				audioFile = correct
					? this.assets.correct2
					: this.assets.incorrect2;
			}
		} else if (task === 3) {
			if (ifOneCorrect && isNormingActive) {
				audioFile = this.assets.ifonecorrect3;
			} else {
				audioFile = correct
					? this.assets.correct3
					: this.assets.incorrect3;
			}
		}

		if (audioFile) {
			const myCallback = () => {
				setTimeout(() => updateStepData({feedbackDone: true}), 2000);
			};
			audioFile.on('end', myCallback);
			audioFile.play();
		}
	};

	render() {
		const {currentStep, ageGroup} = this.props;
		const introSteps = ageGroup === 6 || ageGroup === 7 ? 3 : 4;

		return (
			<Fragment>
				{currentStep === 0 && (
					<Fragment>
						<p>
							<AudioPlayer
								autoplay
								inline
								src={this.intro_audio}
							/>
						</p>
						<p>
							{ageGroup === 6 || ageGroup === 7
								? strings.sp_intro1_norming
								: strings.formatString(
										strings.sp_intro1,
										<b>{'Gul og Sol'}</b>,
										<i>{strings.sp_intro_reminder}</i>,
										<i>{'første lyden'}</i>
								  )}
						</p>
						{ageGroup === 6 || ageGroup === 7 ? (
							<div className="spoonerism-examples">
								<div className="example">
									<div className="example-box">
										<b>{`S`}</b>OL - <b>{`M`}</b>ÅNE
									</div>
									<div className="arrow">
										<img src={arrow} alt="" />
									</div>
									<div className="example-box">
										<b>{`M`}</b>OL - <b>{`S`}</b>ÅNE
									</div>
								</div>
								<div className="example">
									<div className="example-box">
										<b>{`S`}</b>ITT - <b>{`H`}</b>OPP
									</div>
									<div className="arrow">
										<img src={arrow} alt="" />
									</div>
									<div className="example-box">
										<b>{`H`}</b>ITT - <b>{`S`}</b>OPP
									</div>
								</div>
								<div className="example">
									<div className="example-box">
										<b>{`K`}</b>JOLE - <b>{`F`}</b>ANGE
									</div>
									<div className="arrow">
										<img src={arrow} alt="" />
									</div>
									<div className="example-box">
										<b>{`F`}</b>OLE - <b>{`KJ`}</b>ANGE
									</div>
								</div>
							</div>
						) : (
							<div className="spoonerism-examples">
								<div className="example">
									<div className="example-box">
										<b>{`G`}</b>UL - <b>{`S`}</b>OL
									</div>
									<div className="arrow">
										<img src={arrow} alt="" />
									</div>
									<div className="example-box">
										<b>{`S`}</b>UL - <b>{`G`}</b>OL
									</div>
								</div>
								<div className="example">
									<div className="example-box">
										<b>{`M`}</b>ÅNE - <b>{`V`}</b>EGG
									</div>
									<div className="arrow">
										<img src={arrow} alt="" />
									</div>
									<div className="example-box">
										<b>{`V`}</b>ÅNE - <b>{`M`}</b>EGG
									</div>
								</div>
								<div className="example">
									<div className="example-box">
										<b>{`K`}</b>YSS - <b>{`H`}</b>ATT
									</div>
									<div className="arrow">
										<img src={arrow} alt="" />
									</div>
									<div className="example-box">
										<b>{`H`}</b>YSS - <b>{`KJ`}</b>ATT
									</div>
								</div>
							</div>
						)}
						<ReadyButton onReadyChange={this.props.setReady} />
					</Fragment>
				)}
				{currentStep > 0 && currentStep < introSteps && (
					<div className="Spoonerism">
						<img className="listen-image" src={listen} alt="" />
						<p>
							{strings.sp_instruction}
							<br />
							{strings.practiceTasks}
						</p>
					</div>
				)}
				{currentStep === introSteps && (
					<Fragment>
						<p>
							<AudioPlayer
								autoplay
								inline
								src={
									this.intro_audio_end
								} /* {this.assets.spoonerismIntroEnd} */
							/>{' '}
							{strings.sp_intro3}
						</p>
						<ReadyButton onReadyChange={this.props.setReady} />
					</Fragment>
				)}
			</Fragment>
		);
	}
}

export default Intro;
